import { Injectable } from '@angular/core';
import { createEffect, Actions, ofType } from '@ngrx/effects';

import { map, switchMap, withLatestFrom, catchError } from 'rxjs/operators';
import { of } from 'rxjs';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { APIService } from '../../services/api/api.service';

import * as fromMessage from './message.reducer';
import * as MessageActions from './message.actions';
import * as CustomerActions from '../customer/customer.actions';
import { Store } from '@ngrx/store';
import * as CustomerSelectors from '../customer/customer.selectors';

@Injectable()
export class MessageEffects {
  constructor(
    private actions$: Actions,
    private apiService: APIService,
    private notification: NzNotificationService,
    private store: Store
  ) {}

  loadMessages$ = createEffect(() =>
    this.actions$.pipe(
      ofType(MessageActions.loadMessages),
      switchMap(action =>
        this.apiService
          .getMessages(action.filters)
          .pipe(
            map(messages => MessageActions.loadMessagesSuccess({ messages })),
            catchError(error => {
              console.error('Error', error);
              this.notification.error('Error', 'Unable to load messages.');
              return of(MessageActions.loadMessagesFailure({ error }));
            })
          )
      )
    )
  );

  sendMessage$ = createEffect(() =>
    this.actions$.pipe(
      ofType(MessageActions.sendMessage),
      withLatestFrom(this.store.select(CustomerSelectors.selectCurrentCustomerId)),
      switchMap(([action, customerId]) => {
        if (!customerId || action.message.customerId !== customerId) {
          return of(
            MessageActions.sendMessageFailure({ error: 'Selected customer does not match this request' as any })
          );
        }
        return this.apiService
          .sendMessage(action.message)
          .pipe(
            map(message =>
              MessageActions.sendMessageSuccess({ message, updateWatchList: action.updateWatchList })
            ),
            catchError(error => {
              console.error('Error', error);
              this.notification.error('Error', 'Error Sending Message.');
              return of(MessageActions.sendMessageFailure({ error }));
            })
          );
      })
    )
  );

  sendMessageSuccess = createEffect(() =>
    this.actions$.pipe(
      ofType(MessageActions.sendMessageSuccess),
      map((action)=> CustomerActions.updateWatchlist({ isAdd: action.updateWatchList }))
    )
  );
}
